import { isShareLinkContentOverrideEnabled } from "routes/schedule/plugins/share-link-comments/share-link-content-overrides-feature-flag"
import { hasOverride } from "library/extend-schedule.mjs"

// Plug gates for the inline content-override editors on the tailoring surface (FIQ-1631).
// Overrides are persisted tailoring data: extend-schedule.mjs applies them to every display surface
// regardless of the rollout flag, so turning the flag off must not make them vanish from the
// tailoring view (QA saw the pre-override master text there while the schedule view still showed
// the override). With the flag on the inline editors always replace the stock tailoring content;
// with it off they replace it only where a stored override exists, and ContentOverrideField then
// renders that override read-only instead of an editor.

export function showIntroOverride({ payload } = {}) {
    return (
        isShareLinkContentOverrideEnabled() ||
        hasOverride(payload?.introContentOverride) ||
        hasOverride(payload?.introNoteOverride)
    )
}

export function showTaskTitleOverride(context) {
    return isShareLinkContentOverrideEnabled() || hasOverride(getPayloadTask(context)?.titleOverride)
}

export function showTaskContentOverride(context) {
    return isShareLinkContentOverrideEnabled() || hasOverride(getPayloadTask(context)?.contentOverride)
}

export function showTaskNoteOverride(context) {
    return isShareLinkContentOverrideEnabled() || hasOverride(getPayloadTask(context)?.noteOverride)
}

// At the task slots the bound `target` is the master task; overrides live on the payload task keyed
// by task id. Read-only lookup mirroring usePayloadTask, without creating empty payload entries.
function getPayloadTask({ payload, target } = {}) {
    return payload?.tasks?.[target?.id]
}
